"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: {
    network: Object
  },
  data: function data() {
    return {
      new_nick: '',
      error_message: '',
      event_listeners: [],
      self_user_settings_open: false
    };
  },
  computed: {
    user: function user() {
      return this.network.currentUser();
    },
    modeString: function modeString() {
      var user = this.user;
      if (!user.modes.length) {
        return '';
      }
      return user.modes.reduce(function (acc, item) {
        return acc + item.mode;
      }, '+');
    },
    awayStatus: {
      get: function get() {
        return this.user.away;
      },
      set: function set(val) {
        this.network.ircClient.raw('AWAY', val ? 'Currently away' : '');
      }
    }
  },
  methods: {
    openSelfActions: function openSelfActions() {
      this.self_user_settings_open = true;
      this.error_message = '';
    },
    openProfile: function openProfile() {
      this.$state.$emit('userbox.show', this.user);
    },
    addInfoMessageToBuffer: function addInfoMessageToBuffer(message) {
      var buffer = this.$state.getActiveBuffer();
      var mynick = this.$state.getActiveNetwork().nick;
      this.$state.addMessage(buffer, {
        message: message,
        bodyTemplate: '',
        nick: 'INFO',
        ident: 'INFO',
        hostname: 'INFO',
        target: mynick
      });
    },
    awaitMessage: function awaitMessage(ircClient, matcher) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
          timeout: undefined
        },
        timeout = _ref.timeout;
      var connection = ircClient.connection;
      return new _promise.default(function (resolve, reject) {
        var timeoutHandle;
        if (timeout) {
          timeoutHandle = setTimeout(function () {
            connection.removeListener('message', callback);
            reject(new Error('Timeout expired'));
          }, timeout);
        }
        var callback = function callback(message) {
          try {
            if (matcher(message)) {
              connection.removeListener('message', callback);
              if (timeoutHandle) {
                clearTimeout(timeoutHandle);
              }
              resolve(message);
            }
          } catch (err) {
            connection.removeListener('message', callback);
            if (timeoutHandle) {
              clearTimeout(timeoutHandle);
            }
            reject(err);
          }
        };
        connection.on('message', callback);
      });
    },
    setAvatar: function setAvatar() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var ERR_UNKNOWNCOMMAND, ErrExtJwtUnsupported, respPromise, resp, _resp$params, token;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ERR_UNKNOWNCOMMAND = 421;
              ErrExtJwtUnsupported = new Error('EXTJWT unsupported on this server/gateway'); // send a raw message to the server
              respPromise = _this.awaitMessage(_this.network.ircClient, function (message) {
                if (message.command === String(ERR_UNKNOWNCOMMAND) && message.params[1].toUpperCase() === 'EXTJWT') {
                  throw ErrExtJwtUnsupported;
                }
                return message.command.toUpperCase() === 'EXTJWT' && message.params[0] === '*' && message.params[1] === '*';
              }, {
                timeout: 10 * 60
              });
              _this.network.ircClient.raw('EXTJWT * myway');
              _context.prev = 4;
              _context.next = 7;
              return respPromise;
            case 7:
              resp = _context.sent;
              _resp$params = (0, _slicedToArray2.default)(resp.params, 3), token = _resp$params[2]; // Check if the token is valid
              fetch("https://jwt.eggload.com/verify/?t=".concat(token)).then(function (res) {
                return res.json();
              }).then(function (data) {
                if (data === 'invalid or expired token') {
                  // console.log('invalid or expired token');

                  _this.addInfoMessageToBuffer(_this.$t('userbox_avatar_token_expired'));
                } else if (data.account) {
                  _this.addInfoMessageToBuffer(_this.$t('userbox_avatar_browser_tab_opened'));
                  // Open a new browser tab with the specified url
                  var newWindow = window.open("https://avatar.eggload.com/?jwt=".concat(token), '_blank');

                  // Check if the popup was blocked
                  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    // Show popup blocked message in Italian
                    _this.addInfoMessageToBuffer('Per andare alla pagina è necessario consentire i popup');
                  } else {
                    // Send a message after 120 seconds if window opened successfully
                    setTimeout(function () {
                      _this.addInfoMessageToBuffer(_this.$t('userbox_avatar_nickname_not_registered'));
                    }, 120000);
                  }
                } else {
                  _this.addInfoMessageToBuffer(_this.$t('userbox_avatar_nickname_not_registered'));
                }
              });
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              if (_context.t0 === ErrExtJwtUnsupported) {
                // console.debug('Network does not support EXTJWT');
              }
              throw _context.t0;
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 12]]);
      }))();
    },
    closeSelfUser: function closeSelfUser() {
      this.$emit('close');
    },
    onNewNickSubmit: function onNewNickSubmit(newVal, done) {
      if (this.event_listeners.length) {
        // nick change already in progress
        return;
      }
      this.new_nick = newVal;
      this.changeNick(done);
    },
    changeNick: function changeNick(done) {
      var _context2;
      var nick = (0, _trim.default)(_context2 = this.new_nick).call(_context2);
      if (nick.length === 0) {
        this.error_message = TextFormatting.t('error_empty_nick');
        done();
        return;
      }
      if (nick.match(/(^[0-9])|(\s)/)) {
        this.error_message = TextFormatting.t('error_no_number');
        done();
        return;
      }
      if (nick === this.user.nick) {
        this.error_message = TextFormatting.t('error_nick_in_use', {
          nick: nick
        });
        done();
        return;
      }
      this.error_message = '';
      this.listenForNickEvents(done);
      this.network.ircClient.changeNick(nick);
    },
    listenForNickEvents: function listenForNickEvents(done) {
      var _this2 = this;
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick', function (event) {
        if (event.new_nick !== _this2.user.nick) {
          return;
        }
        _this2.closeNickChange();
      }));
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick in use', function (event) {
        _this2.error_message = TextFormatting.t('error_nick_in_use', {
          nick: event.nick
        });
        _this2.removeNickEventListeners();
        done();
      }));
      this.event_listeners.push(this.listen(this.network.ircClient, 'nick invalid', function (event) {
        _this2.error_message = TextFormatting.t('error_nick_invalid', {
          nick: event.nick
        });
        _this2.removeNickEventListeners();
        done();
      }));

      // Maybe the nickchange will result in an event we are not listening for above
      var timeout = this.setTimeout(function () {
        _this2.error_message = TextFormatting.t('error_unexpected');
        _this2.removeNickEventListeners();
      }, 4000);
      this.event_listeners.push(function () {
        _this2.clearTimeout(timeout);
      });
    },
    removeNickEventListeners: function removeNickEventListeners() {
      while (this.event_listeners.length) {
        this.event_listeners.shift()();
      }
    },
    closeNickChange: function closeNickChange() {
      this.removeNickEventListeners();
      this.self_user_settings_open = false;
    },
    networkSupportsAway: function networkSupportsAway() {
      return this.network.ircClient.network.cap.isEnabled('away-notify');
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SelfUser"]
window._kiwi_exports.components.SelfUser = exports.default ? exports.default : exports;
